__turbopack_context__.v({
  "input": "Input-module__j8lwcG__input",
  "textarea": "Input-module__j8lwcG__textarea",
});
